require('./special-modal.component.scss');

export const SpecialModalController = function(
  $scope,
  $http,
  $modalInstance,
  $cookies,
  $httpParamSerializer,
  PermissionService,
  success,
  permission,
  confirmation,
) {
  $scope.permission = permission;
  $scope.user = PermissionService.userName;
  $scope.has_permission = false;
  $scope.need_password = false;
  $scope.confirmation = confirmation;

  for (const perm of PermissionService.special_permissions) {
    if (permission === perm.name) {
      $scope.has_permission = true;
      $scope.need_password = perm.password;
    }
  }

  $scope.error = false;

  $scope.data = {
    'permission': permission,
    'password': ''
  };

  $scope.cancel = () => $modalInstance.close();

  function get_token() {

    const req_params = {
      'headers': {
        'X-CSRFToken': $cookies.get('csrftoken'),
        'Content-Type': 'application/x-www-form-urlencoded',
      }
    };

    $http.post('/admin/get-token/', $httpParamSerializer($scope.data), req_params).then(
      function successHandler(response) {
        $modalInstance.close();
        success(response.data);
      },
      function errorHandler() {
        $scope.error = true;
      });
  }

  $scope.ok = () => get_token();

  if ($scope.has_permission && !$scope.need_password && !$scope.confirmation) {
    get_token();
  }

};



// WEBPACK FOOTER //
// ./src/core/special-modal/special-modal.component.js